import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import type { BookingView, PartialBooking } from "~/providers/booking-provider";

interface BookingState {
  selectedView: BookingView;
  setSelectedView: (view: BookingView) => void;
  layoutCalendarOpen: boolean;
  setLayoutCalendarOpen: (open: boolean) => void;
}

interface TempBookingStoreState {
  selectedDate: Date;
  bookingDialogOpen: boolean;
  selectedBooking?: PartialBooking;
  tempBooking?: PartialBooking;
  pendingBookingsOpen: boolean;

  setPendingBookingsOpen: (open: boolean) => void;
  getSelectedDate: () => Date;
  setSelectedDate: (selectedDate: Date) => void;
  setTempBooking: (booking: PartialBooking | undefined) => void;
  setBookingDialogOpen: (open: boolean) => void;
  setSelectedBooking: (booking: PartialBooking | undefined) => void;
}

export const useBookingStore = create<BookingState>()(
  devtools(
    persist(
      (set) => ({
        selectedView: "guests",
        layoutCalendarOpen: false,
        setLayoutCalendarOpen: (layoutCalendarOpen) => {
          set(() => ({ layoutCalendarOpen }));
        },
        setSelectedView(view) {
          set(() => ({ selectedView: view }));
        },
      }),
      {
        name: "booking-storage",
      },
    ),
  ),
);

export const useTempBookingStore = create<TempBookingStoreState>()(
  devtools((set, get) => ({
    selectedDate: new Date(),
    bookingDialogOpen: false,
    pendingBookingsOpen: false,
    setPendingBookingsOpen: (pendingBookingsOpen) => {
      set(() => ({ pendingBookingsOpen }));
    },
    getSelectedDate: () => get().selectedDate,
    setSelectedDate: (selectedDate) => {
      set(() => ({ selectedDate }));
    },
    setTempBooking(booking) {
      set(() => ({ tempBooking: booking }));
    },
    setBookingDialogOpen: (open) => {
      set(() => ({ bookingDialogOpen: open }));
    },
    setSelectedBooking: (booking) => {
      set(() => ({ selectedBooking: booking }));
    },
  })),
);
